import beneficiaryFiltersSignal, {
	setBeneficiaryFilters,
} from '@UI/Pages/Beneficiaries/BeneficiaryList/Filters/Signals/beneficiaryFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Checkbox } from '@verclam/ui-kit';
import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';

const ArchivedFilter: React.FC = () => {
	const currentFilters = useSignalValue(beneficiaryFiltersSignal);

	const handleIncludeArchivedChange = React.useCallback((includeArchived: boolean) => {
		setBeneficiaryFilters(beneficiaryFiltersSignal.peek().setIncludeArchived(includeArchived));
	}, []);

	return (
		<Checkbox
			name="beneficiaryIncludeArchived"
			label="Inclure les archivés"
			checked={currentFilters.includeArchived}
			onChange={handleIncludeArchivedChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default ArchivedFilter;
